export const toKebab = (str: string) =>
  str.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);

export const toCamel = (str: string) =>
  str.replace(/-([a-z0-9])/g, (_, c: string) => c.toUpperCase());
